/**
 * @author        quanquan
 * @dateTime      2020-12-11 10:35:26
 * @description   meituanIM utils
 */

import _ from 'lodash'
import MC from '@/module/MC'
import store from '@/conf/home/store'
import { findComponentsDownward } from '@/module/utils'
import { handlerSelfMsgItem } from '@/conf/home/store/meituanIM/utils'
import CryptoJS from 'crypto-js'
import dayjs from 'dayjs'

let $imUsersInstance = null

export const mtIMWsHanlder = (appId, $root) => {
  const { IMWebsocket } = store.state.meituanIM
  const ws = IMWebsocket[appId]
  ws.onopen = function () {
    console.log(`[meituanIM] => appId-${appId}-success: connect success`)
    store.commit('meituanIM/setMtStatus', { status: 1, appId })
    setTimeout(() => {
      wsHeartbeat()
    }, 1000)
  }
  ws.onmessage = function (e) {
    // 用户对商户发送消息上报
    if (_.startsWith(e.data, '{', 0)) {
      store.dispatch('meituanIM/$messageProcessing', { msgItemPayload: JSON.parse(e.data), $root })

      if (_.isEmpty($imUsersInstance)) {
        $imUsersInstance = findComponentsDownward($root, 'viImUsers')[0]
      }

      $imUsersInstance.onPlayAudio()

      // 消息上报
      debUpdateReport()
    }
    // 商户对用户发送消息上报
    if (e.data === '成功') {
      // 消息上报
      debUpdateReport()
    }
    console.log(`[meituanIM] => appId-${appId}-onmessage: ${e.data}`)
  }
  ws.onreconnect = function () {
    console.log(`[meituanIM] => appId-${appId}-reconnecting:...`)
  }
  ws.onerror = function (e) {
    console.error(`[meituanIM] => appId-${appId}-error: ${e}`)
    store.commit('meituanIM/setMtStatus', { status: 0, appId })
    setTimeout(() => {
      wsHeartbeat()
    }, 1000)
  }
}

/**
 * 消息上报
 */
export const debUpdateReport = _.debounce(() => {
  store.dispatch('meituanIM/$pushMessage')
}, 3000, {
  'leading': false,
  'trailing': true
})

/**
 * 解码AES
 */
export const decMsg = (text, key) => {
  let decrypted = CryptoJS.AES.decrypt(text, CryptoJS.enc.Utf8.parse(_.truncate(key, { 'length': 16, 'omission': '' })), {
    iv: CryptoJS.enc.Utf8.parse(key),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

/**
 * 加密AES
 */
export const encMsg = (text, key) => {
  return CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(_.truncate(key, { 'length': 16, 'omission': '' })), {
    iv: CryptoJS.enc.Utf8.parse(key),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

/**
 * 时间格式解析
 */
export const timeUnix = (t, f = 'YYYY-MM-DD HH:mm:ss') => dayjs.unix(t).format(f)

/**
 * 当前时间
 */
export const curTime = () => dayjs(new Date()).unix()

/**
 * 发送消息
 */
export const mtIMSend = async (opt, $root) => {
  const { IMWebsocket, msgSearchParams, storeSearchParams, cacheAppSecret } = store.state.meituanIM
  const { onlineStoreCode, thirdUserId } = msgSearchParams
  const { onlineClientCode } = storeSearchParams
  const { appSecret, appId, merCode } = _.find(cacheAppSecret, ['onlineClientCode', onlineClientCode])
  const itemWs = IMWebsocket[`${appId}_WMOPEN`]

  // 数据结构
  const msgItem = {
    'msg_content': encMsg(opt.msg_content, appSecret),
    'msg_type': (() => {
      switch (opt.msg_type) {
        case 'text':
          return '1'
        case 'img':
          return '2'
        case 'voice':
          return '3'
      }
    })(),
    'app_poi_code': `${onlineStoreCode}`,
    'msg_id': `1${_.truncate(`${thirdUserId}`, { 'length': 8, 'omission': '' })}${dayjs(new Date()).unix()}`,
    'app_id': `${appId}`,
    'msg_source': 1,
    'cts': `${curTime()}`,
    'open_user_id': `${thirdUserId}`
  }

  // 发送消息
  await itemWs.send(JSON.stringify(msgItem))

  console.log(`[meituanIM] => 存储上报数据-`, msgItem)

  // 存储上报数据
  store.dispatch('meituanIM/$pushSendChatMsg', { msgItemPayload: msgItem })

  // 存储到当前聊天框
  store.commit('meituanIM/setSingleMtImMsgData', {
    ...handlerSelfMsgItem(msgItem),
    merCode,
    msgContent: opt.msg_content
  })
  // 滚动到最底部
  findComponentsDownward($root, 'vi-cs-content')[0].onScroll('bottom')
}

const resendToRongInitialize = _.once((ws, p) => {
  ws.send(JSON.stringify({ ...p, cmd: 1 }))
  console.log('[meituanIM] => 第一次上报状态成功', { ...p, cmd: 1 })
})

/**
 * 融云心跳
 */
export const wsHeartbeat = () => {
  const { rongStatus, mtStatus, IMWebsocket } = store.state.meituanIM
  const ws = IMWebsocket['RongCloud']
  const cToken = MC.getAuth()
  const p = {
    account: MC.config.userInfo.id, // 账号
    accountType: 1, // eslint-disable-line // 账号类型，1-客服，2-非客服
    cmd: 2,
    deviceId: '1111',
    merCode: global.merCode,
    msgtype: 1,
    platform: 3,
    platformVersion: 'v1',
    systemType: 2,
    token: cToken,
    version: 1,
    rongStatus: rongStatus,
    mtStatus: mtStatus
  }
  // 调用一次
  setTimeout(() => {
    resendToRongInitialize(ws, p)
  }, 3000)

  window.setInterval(() => {
    ws.send(JSON.stringify(p))
    console.log('[meituanIM] => 第N次上报状态成功', p)
  }, 1000 * 30)
}



// WEBPACK FOOTER //
// ./src/js/module/components/mtIm/_source/utils.js